import { ReloadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    noMargin?: boolean;
    onRefreshButtonClick: (...args: any) => any | Promise<any>;
}
export default function RefreshButton({ onRefreshButtonClick, noMargin }: Props) {
    const { t } = useTranslation('common');
    const [isRefreshingData, setIsRefreshingData] = useState(false);

    if (!onRefreshButtonClick) return null;

    const handleRefresh = async () => {
        setIsRefreshingData(true);
        await onRefreshButtonClick();
        setIsRefreshingData(false);
    };

    return (
        <Tooltip title={t('refresh')}>
            <Button
                shape="circle"
                type="text"
                loading={isRefreshingData}
                icon={<ReloadOutlined style={noMargin ? { margin: 0 } : {}} />}
                onClick={handleRefresh}
                size="small"
            />
        </Tooltip>
    );
}
